import { DateTime } from "luxon"

//PrimeReact
import assessStyles from "../../../styles/assessments/Assessment.module.css"

//styling
import { classNames } from "primereact/utils"
import myStyles from "../../../styles/assessments/AssessmentForm.module.css"

export default function AssessmentFormGroupHeader({
  group,
  displayScore,
  scores,
}) {
  const calculateScore = () => {
    const myScore = scores?.find((s) => s.questionGroupId === group.id)

    if (myScore?.score !== null && myScore?.score !== undefined) {
      return (
        <>
          <span className={assessStyles.scoreLabel}>Score:</span>{" "}
          <span className={assessStyles.scoreValue}>{myScore.score}</span>
        </>
      )
    }

    if (myScore?.dateValue) {
      const dateValue = DateTime.fromISO(myScore.dateValue).toLocaleString()

      return (
        <>
          <span className={assessStyles.scoreLabel}>Date:</span>{" "}
          <span className={assessStyles.scoreValue}>{dateValue}</span>
        </>
      )
    }

    return null
  }

  return (
    <div
      className={classNames(myStyles.assessmentFormGroupHeaderLayout, {
        [myStyles.assessmentFormGroupHeaderLayoutWithScore]: displayScore,
      })}
    >
      <div className={myStyles.assessmentFormGroupHeaderLayoutDescription}>
        {group.name}
      </div>
      {displayScore && (
        <div className={myStyles.assessmentFormGroupHeaderLayoutScore}>
          {calculateScore()}
        </div>
      )}
    </div>
  )
}
